import {
    AdministrativeContractIcon,
    BillingContractIcon,
    TechnicalContractIcon
} from '../../../../utils/SVGIcon';

const typeIcon = [
    {
        key: 'administrative',
        icon: <AdministrativeContractIcon />
    },
    {
        key: 'billing',
        icon: <BillingContractIcon />
    },
    {
        key: 'technical',
        icon: <TechnicalContractIcon />
    }
];
function AddressTypesItem({ data }) {
    return data?.map((item) => (
        <div
            key={item?.key}
            className="w-full md:w-64 flex flex-row justify-start items-center gap-4 bg-secondary-50 p-2 md:p-4.5 border border-secondary-200 rounded-10 md:rounded-[15px]"
        >
            <div className="w-8 md:w-12 text-success">
                {typeIcon?.find((icon) => icon?.key === item?.key)?.icon}
            </div>
            <h4 className="text-base md:text-xl font-medium text-primary">{item?.title}</h4>
        </div>
    ));
}

function AddressTypes({ data }) {
    return (
        <div className="contract_type ">
            <div className="contract_type_title mb-4">
                <h3 className="text-lg font-medium text-primary">Address Types</h3>
            </div>
            <div className="contract_type_body flex flex-wrap justify-start items-center gap-2 md:gap-5">
                <AddressTypesItem data={data} />
            </div>
        </div>
    );
}

export default AddressTypes;
